export const getQuizType = (type: number) => {
    switch (type) {
      case 1:
        return "Nhiều lựa chọn văn bản";
      case 2:
        return "Nhiều lựa chọn hình ảnh";
      case 3:
        return "Nhiều lựa chọn video";
      case 4:
        return "Đúng sai";
      case 5:
        return "Danh sách";
      case 6:
        return "Nhiều câu trả lời văn bản";
      case 7:
        return "Nhiều câu trả lời ảnh";
      case 8:
        return "Nhiều câu trả lời video";
      case 9:
        return "Câu trả lời ngắn";
      case 10:
        return "Điền vào chỗ trống";
      case 11:
        return "Kết nối";
      case 12:
        return "Sắp xếp";
      case 13:
        return "Ghi hình";
      case 14:
        return "Ghi âm";
      case 15:
        return "File đính kèm";
      case 16:
        return "Tính toán";
      case 17:
        return "Tính toán đơn giản";
      case 18:
        return "Tính toán nhiều đáp án";
      case 19:
        return "Trình soạn thảo";
      case 20:
        return "Điền số";
      case 21:
        return "Tự luận";
      case 22:
        return "Kéo thả vào văn bản";
      case 23:
        return "Điền khuyết";
      default:
        return "";
    }
  };